import { rootConfig } from 'config';
import 'devexpress-reporting/dx-webdocumentviewer';
import ko from 'knockout';
import React, { createRef, useEffect, useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import '@devexpress/analytics-core/dist/css/dx-analytics.common.css';
import '@devexpress/analytics-core/dist/css/dx-analytics.material.blue.light.css';
import 'devexpress-reporting/dist/css/dx-webdocumentviewer.css';
import 'devextreme/dist/css/dx.material.blue.light.css';
import 'jquery-ui/themes/base/all.css';
import { ajaxSetup } from '@devexpress/analytics-core/analytics-utils';
import useAuth from 'hooks/useAuth';

interface IProps {
  report?: string;
}

const ReportViewer: React.FC<IProps> = ({ report: providedReport }: IProps) => {
  const { report } = useParams();
  const reportUrl = useMemo(() => providedReport ?? report, [providedReport, report]);
  const viewerRef: any = createRef();
  const requestOptions = {
    host: `${rootConfig.serverUrl}/`,
    invokeAction: 'DXXRDV',
  };
  const { accessToken } = useAuth();

  useEffect(() => {
    let mounted = true;

    if (!viewerRef) return undefined;

    if (mounted) {
      ajaxSetup.ajaxSettings = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      ko.applyBindings(
        {
          reportUrl: ko.observable(reportUrl),
          requestOptions: requestOptions,
        },
        viewerRef.current,
      );
    }

    return () => {
      mounted = false;
    };
  }, [report, reportUrl, requestOptions, accessToken]);

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <div ref={viewerRef} data-bind='dxReportViewer: $data'></div>
    </div>
  );
};

export default ReportViewer;
